/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_1_ValueInputs */

const en_services_delivery_1_value = /** @type {(inputs: Services_Delivery_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deliverables, timeline and price agreed before building.`)
};

const lv_services_delivery_1_value = /** @type {(inputs: Services_Delivery_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezultāti, termiņš un cena saskaņoti pirms izstrādes.`)
};

/**
* | output |
* | --- |
* | "Deliverables, timeline and price agreed before building." |
*
* @param {Services_Delivery_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_1_value = /** @type {((inputs?: Services_Delivery_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_1_value(inputs)
	return en_services_delivery_1_value(inputs)
});